import Image from 'next/image'
import React from 'react'

import { pxToRem } from '@/shared/styles/themes'
import { styled, Typography } from '@mui/material'

import { ourStoryData } from '../mocks/ourStory/data'

export const OurStoryIntro: React.FC = () => {
  const { title, subtitle, paragraphs, founderImage } = ourStoryData.intro
  const { pullQuote } = ourStoryData.mission

  return (
    <div>
      <StyledTitle variant="h1">
        {title}
      </StyledTitle>
      <StyledSubtitle variant="h2">
        {subtitle}
      </StyledSubtitle>
      <StyledContent>
        <StyledAvatarWrapper>
          <StyledAvatar>
            <Image
              src={founderImage}
              alt="Carol, founder of Pixie World"
              fill
              style={{ objectFit: 'cover' }}
            />
          </StyledAvatar>
        </StyledAvatarWrapper>
        {paragraphs.map((paragraph, index) => (
          <StyledParagraph key={index} variant="body1">
            {paragraph}
          </StyledParagraph>
        ))}
      </StyledContent>
      <StyledPullQuote variant="h3">
        &ldquo;{pullQuote}&rdquo;
      </StyledPullQuote>
    </div>
  )
}

const StyledTitle = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  fontWeight: 600,
  marginBottom: pxToRem(16),
  fontSize: pxToRem(32),
  color: theme.palette.primary.main,

  [theme.breakpoints.up('md')]: {
    fontSize: pxToRem(42),
    marginBottom: pxToRem(20),
  },
}))

const StyledSubtitle = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  fontWeight: 400,
  fontSize: pxToRem(18),
  color: theme.palette.primary.main,
  marginBottom: pxToRem(32),
  fontStyle: 'italic',

  [theme.breakpoints.up('md')]: {
    fontSize: pxToRem(22),
    marginBottom: pxToRem(40),
  },
}))

const StyledContent = styled('div')({
  overflow: 'hidden',
})

const StyledAvatarWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: pxToRem(24),

  [theme.breakpoints.up('md')]: {
    float: 'right',
    display: 'block',
    margin: `0 0 ${pxToRem(16)} ${pxToRem(24)}`,
    shapeOutside: 'ellipse(50% 50%)',
  },
}))

const StyledAvatar = styled('div')(({ theme }) => ({
  position: 'relative',
  width: pxToRem(180),
  height: pxToRem(210),
  borderRadius: '60% 40% 30% 70% / 50% 60% 40% 50%',
  overflow: 'hidden',
  border: '4px solid white',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
  flexShrink: 0,

  [theme.breakpoints.up('md')]: {
    width: pxToRem(240),
    height: pxToRem(280),
  },
}))

const StyledParagraph = styled(Typography)(({ theme }) => ({
  fontSize: pxToRem(16),
  lineHeight: 1.8,
  marginBottom: pxToRem(24),
  color: theme.palette.primary.main,

  [theme.breakpoints.up('md')]: {
    fontSize: pxToRem(18),
    marginBottom: pxToRem(28),
  },

  '&:last-child': {
    marginBottom: 0,
  },
}))

const StyledPullQuote = styled(Typography)(({ theme }) => ({
  marginTop: pxToRem(32),
  fontSize: pxToRem(18),
  fontWeight: 500,
  fontStyle: 'italic',
  lineHeight: 1.6,
  color: theme.palette.primary.main,
  borderLeft: `4px solid ${theme.palette.primary.main}`,
  paddingLeft: pxToRem(20),

  [theme.breakpoints.up('md')]: {
    marginTop: pxToRem(40),
    fontSize: pxToRem(22),
  },
}))
